import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class DeleteDocumentType implements Parameter {
	public documentIds?: Array<string>;

	constructor(data: any) {
		this.documentIds = FunctionHelper.exists(data?.documentIds) ? data.documentIds : [];
	}

	public static getDocumentIdsDefault(): Array<string> {
		return [];
	}

	public static fromJson(data: any): DeleteDocumentType {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new DeleteDocumentType(data);
	}

	public toJson(): any {
		return {
			'documentIds': this.documentIds
		};
	}

	public clone(): DeleteDocumentType {
		return DeleteDocumentType.fromJson(this.toJson());
	}
}